import React from "react";
import { useLocation } from "react-router-dom";
import { breadcrumbs } from "../../core/data/interface/interface";
import { all_routes } from "../router/all_routes";

const Breadcrumbs = (props: breadcrumbs) => {
  const routes = all_routes;
  const location = useLocation();
  let addButton = null;
  if (
    location.pathname === routes.listinggrid ||
    location.pathname === routes.listinglist ||
    location.pathname === routes.bookingcheckout ||
    location.pathname === routes.booking ||
    location.pathname === routes.invoice ||
    location.pathname === routes.listingdetails ||
    location.pathname === routes.ourteam ||
    location.pathname === routes.testimonial ||
    location.pathname === routes.termsconditions ||
    location.pathname === routes.privacypolicy ||
    location.pathname === routes.aboutus ||
    location.pathname === routes.services ||
    location.pathname === routes.pricing ||
    location.pathname === routes.faq ||
    location.pathname === routes.gallery ||
    location.pathname === routes.bloglist ||
    location.pathname === routes.bloggrid ||

    location.pathname === routes.contact
  ) {
    addButton = null;
  }


  else if (location.pathname === routes.dashboard ||
    location.pathname === routes.messages ||
    location.pathname === routes.payment ||
    location.pathname === routes.reviews ||
    location.pathname === routes.userbookings ||
    location.pathname === routes.userBookingUpcoming ||
    location.pathname === routes.userBookingCancelled ||
    location.pathname === routes.userBookingInprogress ||
    location.pathname === routes.userBookingComplete ||
    location.pathname === routes.wallet ||
    location.pathname === routes.integration) {
    addButton = null;
  }



  else {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
        </div>
        <div className="col-auto float-end ms-auto"></div>
      </div>
    );
  }
  return (
    <>
      {addButton}
    </>
  );
};

export default Breadcrumbs;
